/**
 * The project tab strip (APP_SPEC), worn in Ant Design: sibling
 * screens under one project param. The shell owns it -- modules never
 * link to each other; the URL (params AND the filter search) carries
 * across tabs. Router Links wrapped in Button keep navigation the
 * router's business and looks antd's.
 */
import { Link } from '@tanstack/react-router';
import { Button, Space } from 'antd';

const TABS = [
  { key: 'viewer', label: 'Viewer', to: '/projects/$projectId' },
  { key: 'takeoff', label: 'Takeoff', to: '/projects/$projectId/takeoff' },
  { key: 'diff', label: 'Diff', to: '/projects/$projectId/diff' },
  { key: 'review', label: 'Review', to: '/projects/$projectId/review' },
] as const;

export function ProjectTabs({
  projectId,
  active,
}: {
  projectId: string;
  active: (typeof TABS)[number]['key'];
}) {
  return (
    <Space size="small">
      {TABS.map((tab) => (
        <Link
          key={tab.key}
          to={tab.to}
          params={{ projectId }}
          search={(prev: Record<string, unknown>) => prev}
          style={{ textDecoration: 'none' }}
        >
          <Button size="small" type={tab.key === active ? 'primary' : 'default'}>
            {tab.label}
          </Button>
        </Link>
      ))}
    </Space>
  );
}
